export const ModalBorders = (props: { isDarkTheme?: boolean }) => {
  const { isDarkTheme = false } = props
  return (
    <div className={isDarkTheme ? "text-gray-400" : "text-white"}>
      <svg
        viewBox="0 0 375 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        className="absolute block w-full h-[7px] bottom-full left-0 border-0 outline-0 z-1"
      >
        <path
          d="M355.076 1.44924C355.076 1.44924 371.481 5.07078 372.989 6.03539L375 7H187.5H0L2.01072 6.03539C3.01609 5.55309 24.9757 1.09312 24.9757 1.09312C24.9757 1.09312 40.7863 2.76834 50.8808 2.13263C54.824 1.8843 61.1431 0 61.1431 0C61.1431 0 67.2703 1.91333 71.3553 2.38013C79.4107 3.30064 92.0527 4.37972 92.0527 4.37972L100.827 2.38013L113.177 2.87984L124.927 4.37972L136.77 1.20585L138.834 2.87984L146.254 3.98464L152.268 1.73662C152.268 1.73662 165.317 3.78181 169.921 3.98464C174.708 4.19553 177.286 2.96 182.061 2.63243C191.926 1.95566 206.296 3.32938 207.423 3.10918C208.551 2.88898 215.984 0.769153 215.984 0.769153L221.43 2.8642L232.615 1.09312L241.141 3.76973L251.04 4.99533L262.382 2.38013L274.277 3.42152L291.567 1.73662C291.567 1.73662 307.097 5.01128 317.004 3.98464C322.005 3.46645 329.359 0.760522 329.359 0.760522C329.359 0.760522 332.243 2.80833 334.274 3.18023C337.447 3.76139 342.616 2.63242 342.616 2.63242C347.451 4.23856 355.076 1.44924 355.076 1.44924Z"
          fill="currentColor"
        />
      </svg>
      <svg
        viewBox="0 0 7 575"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        className="absolute hidden laptop:block w-[7px] h-full left-full top-0 border-0 outline-0 z-1"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V0.252564L0 575L4.5528 544.747L5.35683 518.573L3.10294 482.701L4.5528 446.682L3.10294 425.057L5.35662 405.247L4.5528 362.92L3.49888 320.595L6.14773 284.772L4.20852 253.812L6.14773 242.465L2.73942 203.238L3.49888 166.174L3.49888 131.43L7 64.2766L4.5528 24.3038L0 0Z"
          fill="currentColor"
        />
      </svg>
      <svg
        viewBox="0 0 1266 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        className="absolute hidden laptop:block w-full h-[7px] top-full left-0 border-0 outline-0 z-1"
      >
        <path
          d="M67.2638 5.55076C67.2638 5.55076 11.8794 1.92922 6.78833 0.964608L0 0L633 0L1266 0L1259.21 0.964608C1255.82 1.44691 1181.68 5.90688 1181.68 5.90688C1181.68 5.90688 1128.31 4.23166 1094.23 4.86737C1080.91 5.1157 1059.58 7 1059.58 7C1059.58 7 1038.9 5.08667 1025.1 4.61987C997.91 3.69936 955.23 2.62028 955.23 2.62028L925.608 4.61987L883.914 4.12016L844.246 2.62028L804.263 5.79415L797.295 4.12016L772.247 3.01536L751.943 5.26338C751.943 5.26338 707.891 3.21819 692.347 3.01536C676.187 2.80447 667.482 4.04 651.362 4.36757C618.059 5.04434 569.546 3.67062 565.739 3.89082C561.931 4.11102 536.839 6.23085 536.839 6.23085L518.451 4.1358L480.692 5.90688L451.909 3.23027L418.488 2.00467L380.199 4.61987L340.042 3.57848L281.67 5.26338C281.67 5.26338 229.24 1.98872 195.794 3.01536C178.912 3.53355 154.084 6.23948 154.084 6.23948C154.084 6.23948 144.347 4.19167 137.492 3.81977C126.779 3.23861 109.328 4.36758 109.328 4.36758C93.0049 2.76144 67.2638 5.55076 67.2638 5.55076Z"
          fill="currentColor"
        />
      </svg>
      <svg
        viewBox="0 0 7 575"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        className="absolute hidden laptop:block h-full w-[7px] top-0 right-full border-0 outline-0 z-1"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 575V574.747L7 0L2.4472 30.2534L1.64317 56.4275L3.89706 92.2993L2.4472 128.318L3.89706 149.943L1.64338 169.753L2.4472 212.08L3.50112 254.405L0.85227 290.228L2.79148 321.188L0.85227 332.535L4.26058 371.762L3.50112 408.826L3.50112 443.57L0 510.723L2.4472 550.696L7 575Z"
          fill="currentColor"
        />
      </svg>
    </div>
  )
}
